import React, { useState, useEffect } from "react";
import {
  fetchAllDivision,
  fetchAllDivisionCM,
  fetchDivisionalByEmail,
  fetchRegionByEmail,
  fetchDistritoByEmail,
  fetchAdmin,
} from "../Api/fetchAdmin";
import { Select } from "antd";
import { UseAuth } from "../hooks";
import { useNavigate } from "react-router-dom";
import { useRole } from "../context/RoleContext";
import { authProvider } from "../context/authProvider";

export const SelectBranchPage = () => {
  const navigate = useNavigate();
  const { userRol: rol, userEmail } = useRole();
  const [divisiones, setDivisiones] = useState([]);
  const [regiones, setRegiones] = useState([]);
  const [distritos, setDistritos] = useState([]);
  const [unidades, setUnidades] = useState([]);

  const [selectedDivision, setSelectedDivision] = useState(null);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const [selectedUnit, setSelectedUnit] = useState(null);

  const [isLoadingRegions, setIsLoadingRegions] = useState(false);
  const [isLoadingDistricts, setIsLoadingDistricts] = useState(false);
  const [isLoadingUnits, setIsLoadingUnits] = useState(false);
  const { signIn } = UseAuth();

  const getUserData = async () => {
    // TODO MEJORAR ESTAS LLAMADAS QUE SE HACEN EN VARIOS LUGARES
    const response = await authProvider.acquireTokenSilent({
      scopes: ["openid", "profile", "email", "offline_access", "user.read"],
      account: authProvider.accountInfo, // Replace with the scopes required for your API
    });
    const expiration = response.idTokenClaims.iat.toString();
    const token = await authProvider.getAccessToken();
    const idToken = token.accessToken;
    await signIn(idToken, expiration, response.uniqueId);
    const responseToken = await fetch(
      ` https://graph.microsoft.com/v1.0/me?$select=employeeID,displayName,givenName,jobTitle,mail,surname,companyName,onPremisesExtensionAttributes,lastPasswordChangeDateTime,accountEnabled,userPrincipalName`,
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      }
    );
    const responseJson = await responseToken.json();
    return responseJson;
  };

  const getAllDivision = async () => {
    console.log("rolllll", rol);
    const onFailure = ({ error }) => {
      console.log("getAllDivision Error", error);
    };
    const onSuccess = async ({ data }) => {
      const select = { label: "Selecciona una División", value: null };
      const result = [
        select,
        ...data.body.data.map((division) => {
          return { label: division.nombrepersona, value: division.correo };
        }),
      ];
      setDivisiones(result);
    };
    if (rol === "directorMarca") {
      const responseJson = await getUserData();
      const ceco =
        responseJson.onPremisesExtensionAttributes.extensionAttribute6 != null
          ? responseJson.onPremisesExtensionAttributes.extensionAttribute6
          : responseJson.employeeId != null
            ? responseJson.employeeId
            : "0";
      const jobTitle = responseJson.jobTitle;
      const company = responseJson.companyName;
      fetchAdmin(company, ceco, jobTitle)
        .then(({ data, config }) => {
          console.log("brandfcNombre ", data.body.brand.FCNOMBRE);
          fetchAllDivisionCM(data.body.brand.FCNOMBRE).then(onSuccess).catch(onFailure);
        })
        .catch(onFailure);
    } else {
      fetchAllDivision().then(onSuccess).catch(onFailure);
    }
  };

  useEffect(() => {
    if (divisiones.length === 2) {
      setSelectedDivision(divisiones[1].value);
      getDivisionaleByEmail(divisiones[1].value);
    }
  }, [divisiones]);

  const getDivisionaleByEmail = async (email) => {
    if (email) {
      setIsLoadingRegions(true);
      const { data } = await fetchDivisionalByEmail(email);
      const select = { label: "Selecciona una Región", value: null };
      const result = [
        select,
        ...data.body.data.divisional.map((region) => {
          return { label: region.nombrepersona, value: region.correo };
        }),
      ];
      setRegiones(result);
      setIsLoadingRegions(false);
    }
  };

  useEffect(() => {
    if (regiones.length === 2) {
      setSelectedRegion(regiones[1].value);
      getRegionByEmail(regiones[1].value);
    }
  }, [regiones]);

  const getRegionByEmail = async (email) => {
    if (email) {
      setIsLoadingDistricts(true);
      const { data } = await fetchRegionByEmail(email);
      const select = { label: "Seleccione un Distrito", value: null };
      const result = [
        select,
        ...data.body.data.distrito.map((distrito) => {
          return { label: distrito.nombrepersona, value: distrito.correo };
        }),
      ];
      setDistritos(result);
      setIsLoadingDistricts(false);
    }
  };

  useEffect(() => {
    if (distritos.length === 2) {
      setSelectedDistrict(distritos[1].value);
      getDistritoByEmail(distritos[1].value);
    }
  }, [distritos]);

  const getDistritoByEmail = async (email) => {
    if (email) {
      setIsLoadingUnits(true);
      const { data } = await fetchDistritoByEmail(email);
      const select = { label: "Seleccione una Sucursal", value: null };
      const result = [
        select,
        ...data.body.data.map((unidad) => {
          return { label: unidad.FISUCURSALID, value: unidad.FISUCURSALID };
        }),
      ];
      setUnidades(result);
      setIsLoadingUnits(false);
    }
  };

  useEffect(() => {
    const loadDataForRole = async () => {
      resetAllSelections();
      if (["director", "directorMarca"].includes(rol)) {
        getAllDivision();
      } else if (rol === "divisional") {
        getDivisionaleByEmail(userEmail);
      } else if (rol === "regional") {
        getRegionByEmail(userEmail);
      } else if (rol === "distrital") {
        getDistritoByEmail(userEmail);
      }
    };
    if (rol && userEmail) {
      loadDataForRole();
    }
  }, [rol, userEmail]);

  const resetAllSelections = () => {
    setSelectedDivision(null);
    setRegiones([]);
    setSelectedRegion(null);
    setDistritos([]);
    setSelectedDistrict(null);
    setUnidades([]);
    setSelectedUnit(null);
  };

  const handleDivisionChange = (value) => {
    console.log(value);
    setSelectedDivision(value);
    setSelectedRegion(null);
    setSelectedDistrict(null);
    setSelectedUnit(null);
    setDistritos([]);
    setUnidades([]);
    getDivisionaleByEmail(value);
  };
  const handleRegionChange = (value) => {
    setSelectedRegion(value);
    setSelectedDistrict(null);
    setSelectedUnit(null);
    setUnidades([]);
    getRegionByEmail(value);
  };

  const handleDistrictChange = (value) => {
    setSelectedDistrict(value);
    setSelectedUnit(null);
    getDistritoByEmail(value);
  };

  const handleUnitChange = (value) => {
    setSelectedUnit(value);
  };

  const handleAccept = async () => {
    let missingFields = [];
    if (["director", "directorMarca"].includes(rol) && !selectedDivision)
      missingFields.push("División");
    if (["director", "directorMarca", "divisional"].includes(rol) && !selectedRegion)
      missingFields.push("Región");
    if (["director", "directorMarca", "divisional", "regional"].includes(rol) && !selectedDistrict)
      missingFields.push("Distrito");
    if (!selectedUnit) missingFields.push("Sucursal");

    navigate("/Home", { state: { ceco: selectedUnit } });
  };

  const styles = {
    mainContainer: {
      padding: "1.2rem",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: 420,
    },
    formContainer: {
      maxWidth: "28rem",
      width: "100%",
      marginLeft: "auto",
      marginRight: "auto",
      backgroundColor: "rgba(28, 42, 56, 0.5)",
      backdropFilter: "blur(4px)",
      borderRadius: "0.75rem",
      padding: "2rem",
      display: "flex",
      flexDirection: "column",
    },
    buttonContainer: {
      paddingTop: "1rem",
    },
    buttonBase: {
      minWidth: 200,
      backgroundColor: "#41b6e6",
      color: "#fff",
      fontWeight: "bold",
      paddingTop: "0.5rem",
      paddingBottom: "0.5rem",
      paddingLeft: "1rem",
      paddingRight: "1rem",
      borderRadius: "0.5rem",
      outline: "none",
      fontSize: "16px",
    },
    buttonHover: {
      backgroundColor: "#4b5563",
    },
    buttonDisabled: {
      backgroundColor: "#6b7280",
      cursor: "not-allowed",
    },
    label: {
      display: "block",
      fontSize: "0.95rem",
      fontWeight: "600",
      marginBottom: "0.5rem",
      marginTop: "1rem",
      color: "#e2e8f0",
      textAlign: "left",
    },
  };

  return (
    <div className="App-body-login">
      <div style={styles.mainContainer}>
        <div style={styles.formContainer}>
          {["director", "directorMarca"].includes(rol) && (
            <>
              <label style={styles.label}>División:</label>
              <Select
                value={selectedDivision}
                onChange={handleDivisionChange}
                options={divisiones}
                style={{ width: 120, textAlign: "left" }}
                placeholder="Selecciona una División"
              />
            </>
          )}
          {["director", "directorMarca", "divisional"].includes(rol) && (
            <>
              <label style={styles.label}>Región:</label>
              <Select
                value={selectedRegion}
                onChange={handleRegionChange}
                options={regiones}
                disabled={
                  !selectedDivision && !["director", "directorMarca", "divisional"].includes(rol)
                }
                style={{ width: 120, textAlign: "left" }}
                placeholder="Selecciona una Región"
              />
            </>
          )}
          {["director", "directorMarca", "divisional", "regional"].includes(rol) && (
            <>
              <label style={styles.label}>Distrito:</label>
              <Select
                value={selectedDistrict}
                onChange={handleDistrictChange}
                options={distritos}
                disabled={
                  !selectedRegion &&
                  !["director", "directorMarca", "divisional", "regional"].includes(rol)
                }
                style={{ width: 120, textAlign: "left" }}
                placeholder="Selecciona un Distrito"
              />
            </>
          )}

          <label style={styles.label}>Sucursal:</label>
          <Select
            value={selectedUnit}
            onChange={handleUnitChange}
            options={unidades}
            disabled={!selectedDistrict && !["distrital"].includes(rol)}
            style={{ width: 120, textAlign: "left" }}
            placeholder="Selecciona una Sucursal"
          />
          <div style={styles.buttonContainer}>
            <button
              onClick={handleAccept}
              type="submit"
              style={{
                ...styles.buttonBase,
                ...(!selectedUnit ? styles.buttonDisabled : {}),
              }}
              disabled={!selectedUnit}
            >
              Aceptar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
